import { useMutation } from '@apollo/client'
import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Box, Button, Flex, Text } from 'rebass/styled-components'
import styled from 'styled-components'
import {
    useCustomerLogin,
    CHECKOUT_CUSTOMER_ASSOCIATE,
    CUSTOMER_ACCESS_TOKEN_CREATE,
} from '../../graphql/mutations'
import IonContent from '../../components/IonContent'
import {
    IonPage,
    IonItem,
    IonLabel,
    IonInput,
    IonButton,
    IonLoading,
    IonTabButton,
    IonToast,
    IonTabs,
} from '@ionic/react'
import Header from '../../components/Header'
import { storage } from '../../utils/index'

export const Input = styled('input')`
    height: 40px;
    border: 1px solid #eee;
    width: 100%;
    padding-left: 15px;
    box-sizing: border-box;
`

export default () => {
    const history = useHistory()
    const [error, setError] = useState('')
    // const [mutate, data, loading] = useCustomerLogin(history)
    const [associate] = useMutation(CHECKOUT_CUSTOMER_ASSOCIATE)
    const [mutate, { data, loading }] = useMutation(CUSTOMER_ACCESS_TOKEN_CREATE, {
        update(cache, { data }) {
            const checkout = storage.getItem('checkout')
            const { customerAccessToken, userErrors } = data.customerAccessTokenCreate
            if (!customerAccessToken) {
                setError(userErrors[0]?.message)
                return
            }

            const { accessToken } = customerAccessToken

            storage.setItem('accessToken', accessToken)
            associate({
                variables: {
                    checkoutId: checkout.id,
                    customerAccessToken: accessToken,
                },
            })
            history.push('/')
        },
    })
    const [obj, setObj] = useState({
        email: '',
        password: '',
    })
    const handleLogin = () => {
        mutate({
            variables: {
                input: obj,
            },
        })
    }

    const handleChange = type => e => {
        setObj({
            ...obj,
            [type]: e.target.value,
        })
    }

    return (
        <IonPage pt="50px" px="30px">
            <Header title="Login"></Header>
            <IonContent>
                <IonItem>
                    <IonLabel>Email</IonLabel>
                    <IonInput value={obj.email} onIonChange={handleChange('email')}></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel>Password</IonLabel>
                    <IonInput
                        value={obj.password}
                        onIonChange={handleChange('password')}
                    ></IonInput>
                </IonItem>

                <Box my="20px" px="20px">
                    <IonButton color="primary" expand="block" onClick={handleLogin}>
                        登录
                    </IonButton>
                    <Flex justifyContent="space-between" mt="10px">
                        <Link to="/register">
                            <Text>Register</Text>
                        </Link>
                        <Link to="/reset">
                            <Text>Reset password</Text>
                        </Link>
                    </Flex>
                </Box>
                <IonToast
                    position="top"
                    isOpen={Boolean(error)}
                    onDidDismiss={() => setError('')}
                    message={error}
                    duration={1200}
                />
                <IonLoading isOpen={loading}></IonLoading>
            </IonContent>
        </IonPage>
    )
}
